"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_helmet_1 = require("react-helmet");
var ScrollingTextBubble_1 = __importDefault(require("../../components/ScrollingTextBubble"));
var Avatar_1 = __importDefault(require("../../components/Avatar"));
var Desk_1 = __importDefault(require("../../components/Desk"));
var Modal_1 = __importDefault(require("../../components/Modal"));
var styles_1 = require("./styles");
var Icon_1 = __importDefault(require("../../components/Icon"));
var Lamp_1 = __importDefault(require("../../components/Lamp"));
var react_spring_1 = require("react-spring");
var constant_1 = require("../../constant");
var styled_components_1 = __importDefault(require("styled-components"));
var calc = function (x, y) {
    if (typeof window === "undefined") {
        return [0, 0];
    }
    return [x - window.innerWidth / 2, y - window.innerHeight / 2];
};
var lampTrans = function () {
    var _a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _a[_i] = arguments[_i];
    }
    var x = _a[0], y = _a[1];
    if (typeof window === "undefined" || window.innerWidth <= 768)
        return "translate3d(0,0,0)";
    return "translate3d(" + x / 12 + "px," + (y / 12 - 60) + "px,0)";
};
var bubbleTrans = function () {
    var _a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _a[_i] = arguments[_i];
    }
    var x = _a[0], y = _a[1];
    if (typeof window === "undefined" || window.innerWidth <= 768)
        return "translate3d(0,0,0)";
    return "translate3d(" + x / 50 + "px," + y / 50 + "px,0)";
};
var avatarTrans = function () {
    var _a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _a[_i] = arguments[_i];
    }
    var x = _a[0], y = _a[1];
    if (typeof window === "undefined" || window.innerWidth <= 768)
        return "translate3d(0,0,0)";
    return "translate3d(" + (x / 15 + 10) + "px," + (y / 15 + 25) + "px,0)";
};
var blackBoardTrans = function () {
    var _a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _a[_i] = arguments[_i];
    }
    var x = _a[0], y = _a[1];
    if (typeof window === "undefined" || window.innerWidth <= 768)
        return "translate3d(0,0,0)";
    return "translate3d(" + x / 30 + "px," + y / 30 + "px,0)";
};
var deskTrans = function () {
    var _a = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _a[_i] = arguments[_i];
    }
    var x = _a[0], y = _a[1];
    if (typeof window === "undefined" || window.innerWidth <= 768)
        return "translate3d(0,0,0)";
    return "translate3d(" + (x / 20 + 50) + "px," + (y / 20 + 20) + "px,0)";
};
var LampContainer = styled_components_1.default(react_spring_1.animated.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  bottom: 600px;\n  left: 50%;\n  z-index: 2;\n  display: none;\n  flex-direction: column;\n\n  @media screen and (max-width: 768px) and (min-height: 600px) {\n    display: flex;\n  }\n\n  ", " {\n    display: flex;\n  }\n\n  ", " {\n    bottom: 700px;\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  bottom: 600px;\n  left: 50%;\n  z-index: 2;\n  display: none;\n  flex-direction: column;\n\n  @media screen and (max-width: 768px) and (min-height: 600px) {\n    display: flex;\n  }\n\n  ", " {\n    display: flex;\n  }\n\n  ", " {\n    bottom: 700px;\n  }\n"])), constant_1.MEDIA.MIN.l, constant_1.MEDIA.MIN.xl);
var Profile = function () {
    var _a = react_1.useState(false), showModal = _a[0], setShowModal = _a[1];
    var _b = react_spring_1.useSpring(function () { return ({
        xy: [0, 0],
        config: { mass: 5, tension: 300, friction: 100 },
    }); }), props = _b[0], set = _b[1];
    var style = {
        position: "fixed",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        zIndex: -1,
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("title", null,
                "Profil - ",
                constant_1.SITE_TITLE),
            react_1.default.createElement("meta", { name: "description", content: "D\u00E9couvrez le profil de Gloria Luzio, d\u00E9veloppeuse React autodidacte et passionn\u00E9e depuis 2019" }),
            react_1.default.createElement("meta", { property: "og:title", content: "Gloria Luzio - d\u00E9veloppeuse Javascript React - Paris" }),
            react_1.default.createElement("meta", { property: "og:description", content: "D\u00E9couvrez le profil de Gloria Luzio, d\u00E9veloppeuse React autodidacte et passionn\u00E9e depuis 2019" }),
            react_1.default.createElement("meta", { property: "og:url", content: "https://www.glorialuzio.fr" })),
        react_1.default.createElement(styles_1.ProfilContainer, { onMouseMove: function (_a) {
                var x = _a.clientX, y = _a.clientY;
                return set({ xy: calc(x, y) });
            } },
            react_1.default.createElement(react_spring_1.animated.div, { style: __assign(__assign({}, style), { transform: props.xy.interpolate(blackBoardTrans) }) },
                react_1.default.createElement(styles_1.BlackBoard, null,
                    react_1.default.createElement(styles_1.BlackBoardPostIt, null),
                    react_1.default.createElement(styles_1.BlackBoardText, { top: 24 }),
                    react_1.default.createElement(styles_1.BlackBoardText, { top: 76 }),
                    react_1.default.createElement(styles_1.BlackBoardText, { top: 132 }))),
            react_1.default.createElement(react_spring_1.animated.div, { style: __assign(__assign({}, style), { transform: props.xy.interpolate(deskTrans) }) },
                react_1.default.createElement(Desk_1.default, null)),
            react_1.default.createElement(react_spring_1.animated.div, { style: __assign(__assign({}, style), { transform: props.xy.interpolate(bubbleTrans) }) },
                react_1.default.createElement(ScrollingTextBubble_1.default, { position: "left", scrollingTexts: [
                        "Bonjour je m'appelle Gloria Luzio, bienvenue sur mon portfolio !",
                        "anciennement infirmière, je me suis reconvertie dans le domaine du développement web / mobile",
                    ] })),
            react_1.default.createElement(react_spring_1.animated.div, { style: __assign(__assign({}, style), { top: undefined, transform: props.xy.interpolate(avatarTrans) }) },
                react_1.default.createElement(Avatar_1.default, null)),
            react_1.default.createElement(LampContainer, null,
                react_1.default.createElement(react_spring_1.animated.div, { style: {
                        flex: 1,
                        transform: props.xy.interpolate(lampTrans),
                    } },
                    react_1.default.createElement(Lamp_1.default, null))),
            react_1.default.createElement(styles_1.SocialNetworkContainer, null,
                react_1.default.createElement(styles_1.LinkLogo, { href: "https://www.linkedin.com/in/gloria-luzio-a7b05819b/", target: "_blanck" },
                    react_1.default.createElement(Icon_1.default, { size: '24px', icon: "linkedin" })),
                react_1.default.createElement(styles_1.LinkLogo, { href: "https://github.com/gloluz", target: "_blanck" },
                    react_1.default.createElement(Icon_1.default, { size: '24px', icon: "github" }))),
            showModal && (react_1.default.createElement(Modal_1.default, { onClose: function () { return setShowModal(false); } },
                react_1.default.createElement("div", null, "D\u00E9tails Techniques"),
                react_1.default.createElement(styles_1.ModalList, null,
                    react_1.default.createElement(styles_1.ListStyle, null, "Except\u00E9 les logos et les miniatures des projets, aucune image n'a \u00E9t\u00E9 utilis\u00E9e. Les illustrations sont d\u00E9velopp\u00E9es uniquement en CSS."),
                    react_1.default.createElement(styles_1.ListStyle, null, "Ce portfolio est d\u00E9velopp\u00E9 en React et Typescript."),
                    react_1.default.createElement(styles_1.ListStyle, null,
                        "Vous pouvez consulter le code source",
                        " ",
                        react_1.default.createElement("a", { href: "https://github.com/gloluz/portfolio", target: "_blank" }, "ici"))))),
            react_1.default.createElement(styles_1.Informations, { onClick: function () { return setShowModal(true); } }, "?"))));
};
exports.default = Profile;
var templateObject_1;
